import { render, staticRenderFns } from "./bd-cell-item.vue?vue&type=template&id=6bb3e57a&scoped=true"
import script from "./bd-cell-item.vue?vue&type=script&lang=js"
export * from "./bd-cell-item.vue?vue&type=script&lang=js"
import style0 from "./bd-cell-item.vue?vue&type=style&index=0&id=6bb3e57a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb3e57a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/tariff/bd-cell/bd-cell-item.vue
// module id = null
// module chunks = 